export default {
    loadData : async function() {
        let listData = require('../assets/weapons/datas/weaponAndSlashDatas.json')
        return listData;
    }
}